<template>
    <div aria-live="assertive">
        <div class="col-xs-12">
            <div class="d-flex-row flex-justify-between">
                <p id="title" role="heading" aria-level="1" tabindex="0"><i class="fa fa-file-o"></i> Declarações</p>
            </div>
        </div>
        <div v-if="!loading">
            <div class="col-xs-12 p-x-sm" v-if="result && result.length > 0">
                <div class="col-xs-12 col-md-6 col-lg-4 p-md" v-for="(declaration) in result" :key="declaration">
                    <div class="card p-20">
                        <div class="d-flex-row flex-justify-between m-b-md">
                            <h4 class="level m-b-sm">{{ declaration.name }}</h4>
                            <small class="info" v-if="declaration.academic">
                                <i class="fa fa-users"></i> {{ declaration.academic_name }}
                            </small>
                        </div>
                        <div class="col-xs-12 m-t-sm text-left">
                            <small>
                                <i class="fa fa-calendar"></i> Emitido em {{ formatDbDatetime(declaration.issue_date) }}
                            </small>
                        </div>
                        <div class="col-xs-12 m-t-sm text-left">
                            <small>
                                <i class="fa fa-map-marker"></i> {{ declaration.place_tree }}
                            </small>
                        </div>
                        <div class="col-xs-12 m-t-lg">
                            <a class="col-xs-12 btn btn-success" :href="declaration.file_url" target="_blank">
                                Visualizar declaração
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <span><b>Não há declarações disponíveis</b></span>
            </div>
        </div>
        <div v-else class="col-xs-12 d-flex-column align-center flex-justify-center text-center h-100vh overflow-hidden">
            <i class="fa fa-5x fa-circle-o-notch fa-spin"></i>
        </div>
    </div>
</template>

<script>

    import { getDeclarationList } from "../../scripts/apiService/declaration";
import { formatDbDatetime } from "../../scripts/utils";

    export default {
        name: 'DeclarationList',
        components: {},
        data: () => { return {
            result: null,
            loading: true
        }},
        methods: {
            formatDbDatetime: formatDbDatetime
        },
        mounted() {
            getDeclarationList().then((response) => {
                this.loading = false;
                this.result = response.data;
                document.getElementById('title').focus();
            });
        },
    }
</script>